<div [formGroup]="form" class="requirement-bands-container">
    <div formArrayName="bands">
        @for (band of bands.controls; track band; let i = $index) {
        <div [formGroupName]="i" class="card mb-3 border shadow-sm">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 class="mb-0 fw-bold text-colonial">Configuración de Requisito #{{ i + 1 }}</h6>
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeBand(i)"
                    title="Eliminar Configuración">
                    <span class="material-symbols-outlined" style="font-size: 1.2rem; vertical-align: middle;">
                        delete
                    </span> Eliminar
                </button>
            </div>
            <div class="card-body">
                <div class="row g-3 mb-3">
                    <h6 class="mt-2 mb-2 small text-muted fw-bold">Rangos de Edad</h6>
                    <div formArrayName="ageRanges">
                        @for (range of getAgeRanges(i).controls; track range; let r = $index) {
                        <div [formGroupName]="r" class="row g-2 align-items-end mb-2">
                            <div class="col-md-5">
                                @if (r === 0) {
                                <label class="form-label small text-muted">Edad Desde</label>
                                }
                                <input type="text" formControlName="ageFrom" class="form-control form-control-sm"
                                    mask="0*">
                            </div>
                            <div class="col-md-5">
                                @if (r === 0) {
                                <label class="form-label small text-muted">Edad Hasta</label>
                                }
                                <input type="text" formControlName="ageTo" class="form-control form-control-sm"
                                    mask="0*">
                            </div>
                            <div class="col-md-2">
                                <button type="button" class="btn btn-outline-danger btn-sm"
                                    (click)="removeAgeRange(i, r)" title="Eliminar Rango de Edad">
                                    <span class="material-symbols-outlined" style="font-size: 18px;">
                                        delete
                                    </span>
                                </button>
                            </div>
                        </div>
                        }
                        <button type="button" class="btn btn-sm btn-outline-colonial" (click)="addAgeRange(i)">
                            <i class="bi bi-plus-circle"></i> Agregar Rango de Edad
                        </button>
                    </div>
                </div>

                <hr class="my-2">

                <!-- Limits List -->
                <h6 class="mt-2 mb-2 small text-muted fw-bold">Rangos por Moneda</h6>
                <div formArrayName="limits" class="mb-3">
                    @for (limit of getLimits(i).controls; track limit; let k = $index) {
                    <div [formGroupName]="k" class="row g-2 align-items-end mb-2">
                        <div class="col-md-3">
                            @if (k === 0) {
                            <label class="form-label small text-muted">Moneda</label>
                            }
                            <select formControlName="currency" class="form-select form-select-sm">
                                @for (curr of currencies; track curr) {
                                <option [value]="curr">{{ curr }}</option>
                                }
                            </select>
                        </div>
                        <div class="col-md-4">
                            @if (k === 0) {
                            <label class="form-label small text-muted">Desde</label>
                            }
                            <div class="input-group input-group-sm">
                                <span class="input-group-text">$</span>
                                <input type="text" formControlName="amountFrom" class="form-control" placeholder="0"
                                    mask="separator.2" thousandSeparator=",">
                            </div>
                        </div>
                        <div class="col-md-4">
                            @if (k === 0) {
                            <label class="form-label small text-muted">Hasta</label>
                            }
                            <div class="input-group input-group-sm">
                                <span class="input-group-text">$</span>
                                <input type="text" formControlName="amountTo" class="form-control"
                                    placeholder="Máx (opcional)" mask="separator.2" thousandSeparator=",">
                            </div>
                        </div>
                        <div class="col-md-1">
                            <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeLimit(i, k)"
                                title="Eliminar Rango">
                                <span class="material-symbols-outlined" style="font-size: 18px;">
                                    delete
                                </span>
                            </button>
                        </div>
                    </div>
                    }
                    <button type="button" class="btn btn-sm btn-outline-colonial" (click)="addLimit(i)">
                        <i class="bi bi-plus-circle"></i> Agregar Rango
                    </button>
                </div>

                <hr class="my-2">

                <!-- Requirements List -->
                <h6 class="mt-2 mb-2 small text-muted fw-bold">Requisitos</h6>
                <div formArrayName="requirements">
                    @for (req of getRequirements(i).controls; track req; let j = $index) {
                    <div [formGroupName]="j" class="input-group input-group-sm mb-2">
                        <span class="input-group-text">{{ j + 1 }}</span>
                        <input type="text" formControlName="name" class="form-control"
                            placeholder="Nombre del Requisito (ej. Examen Médico)">
                        <button type="button" class="btn btn-outline-danger" (click)="removeRequirement(i, j)"
                            title="Eliminar Requisito">
                            <span class="material-symbols-outlined" style="font-size: 18px;">
                                delete
                            </span>
                        </button>
                    </div>
                    }
                    <button type="button" class="btn btn-sm btn-outline-colonial" (click)="addRequirement(i)">
                        <i class="bi bi-plus-circle"></i> Agregar Requisito
                    </button>
                </div>
            </div>
        </div>
        }
    </div>

    @if (bands.length === 0) {
    <div class="text-center p-4 text-muted border rounded bg-light mb-3">
        No hay configuraciones de requisitos configuradas. Agrega una abajo.
    </div>
    }

    <button type="button" class="btn btn-colonial" (click)="addBand()">
        <i class="bi bi-plus-lg"></i> Agregar Configuración
    </button>
</div>